import React, {Component} from 'react';
import HeaderComponent
    from "../../../Components/HeaderComponent/HeaderComponent";
import {Box, Typography} from "@material-ui/core";
import SubHeaderExtract from "./SubHeaderExtract/SubHeaderExtract";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";
import TableExtract from "./TableExtract";
import MessageUtil from "../../../Utils/MessageUtil";
import ExtractService from "../../../Services/ExtractService";
import MeUtil from "../../../Utils/MeUtil";
import {ExtractContext} from "../../../Contexts/ExtractContext";
import ErrorUtil from "../../../Utils/ErrorUtil";
import DateUtil from "../../../Utils/DateUtil";
import FidelityService from "../../../Services/FidelityService";
import FidelityProgramUtil from "../../../Utils/FidelityProgramUtil";
import {BlockClientContext} from "../../../Contexts/BlockClientContext";


class ClientBlockScreen extends Component {
    static ROUTE = '/client-block';

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            erros: [],
            extractList: [],
            dataFilter: null,
            pagination: null,
            fidelity: null,
            filters: {
                start_at: DateUtil.getDateRangeFormat(7).initial,
                end_at: DateUtil.getDateRangeFormat(7).final,
                companies: null,
                page: 1,
                type: null,
                client: null,
                key: null,
                user_name: null,
            },
        };

        this.fidelityService = new FidelityService();
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        try {

            this.setState({
                inLoad: true,
            });


            const fidelity = await FidelityProgramUtil.tryGetFidelity();

            const response = await this.fidelityService.getBlockedUsers({
                fidelityUuid: fidelity.uuid,
                queryString: this.makeQueryString(this.state.filters),
            });

            this.setState({
                inLoad: false,
                extractList: response.data.data,
                pagination: response.data,
                fidelity: fidelity,
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    doSearch = (filter) => {
        this.setState({
            filters: {
                paginate: filter.paginate,
                page: 1,
                filter: filter.filter,
            },
        });

        this.load();
    }

    doChangePage = (filter) => {
        this.setState({
            filters: {
                start_at: filter.selectedDateInitialApi ?? this.state.filters.start_at,
                end_at: filter.selectedDateFinalApi ?? this.state.filters.end_at,
                companies: filter.companies ?? this.state.filters.companies,
                paginate: filter.paginate ?? this.state.filters.paginate,
                page: filter.page ?? this.state.filters.page,
                type: filter.type ?? this.state.filters.type,
                client: filter.client ?? this.state.filters.client,
                key: filter.key ?? this.state.filters.key,
                user_name: filter.user_name ?? this.state.filters.user_name,
            },
        });

        this.load();
    }

    makeQueryString = function (obj) {
        var str = [];
        for (let p in obj) {
            if (!obj[p]) {
                continue;
            }

            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }

        }
        return str.join("&");
    }

    render() {
        return (
            <BlockClientContext.Provider value={{
                parent: this,
            }}>
                <HeaderComponent title={'Extrato'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                <Box display={'flex'}
                     justifyContent={'center'}
                     alignItems={'center'}>
                    <Box width={'80%'}>
                        <Typography align={'center'}
                                    variant={'h6'}
                                    color={'primary'}>
                            Bloqueio de Acesso
                        </Typography>
                        <SpacerComponent height={20}/>
                        <SubHeaderExtract/>
                        <SpacerComponent height={40}/>
                        <TableExtract extractList={this.state.extractList}/>
                        {!this.state.extractList &&
                            <>
                                <SpacerComponent height={120}/>
                                <Typography variant={'body1'}
                                            align={'center'}>
                                    Não foi encontrado registros para o período
                                    de <b>{DateUtil.raw(this.state.initial).toDate()}</b> à <b>{DateUtil.raw(this.state.final).toDate()}</b>
                                </Typography>
                                <SpacerComponent height={120}/>
                            </>
                        }
                    </Box>
                </Box>
            </BlockClientContext.Provider>
        );
    }
}

export default ClientBlockScreen;